import React from "react";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_BANK_ACCOUNTS } from "../../../service/ApolloClient/ApolloQueries";
import { MUTATION_REMOVE_BANK_ACCOUNT } from "../../../service/ApolloClient/ApolloMutation";
import { SuccessToast } from "../../../hoc/ToastNotify/ToastNotify";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { confirmAlert } from "react-confirm-alert"; // Import

class BankAccountList extends React.Component {
  tableRef = React.createRef();

  constructor(props) {
    super(props);

    this.state = {
      data: [],
      columns: [
        {
          title: "#",
          field: "id",
          render: (rowData) => {
            return (
              <a href={`/bank-account/edit/` + rowData.id}>{rowData.id}</a>
            );
          },
        },
        {
          title: "طرف حساب",
          field: "user_fullname",
          render: (rowData) =>
            rowData.user_id ? (
              <a href={`/user/` + rowData.user_id}>{rowData.user_fullname}</a>
            ) : (
              "مشخص نشده"
            ),
        },

        {
          title: "بانک",
          field: "bank",
          render: (rowData) => rowData.bank,
        },
        {
          title: "شعبه",
          field: "branch",
          render: (rowData) => rowData.branch,
        },
        {
          title: "کد شعبه",
          field: "bank_branch",
          render: (rowData) => rowData.branch_code,
        },
        {
          title: "حساب",
          field: "account",
          render: (rowData) => rowData.account,
        },
      ],
    };

    this.remoteData = this.remoteData.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  componentDidMount() {
    // this.fetchData();
  }

  remoteData = (query) => {
    return client
      .query({
        query: QUERY_BANK_ACCOUNTS,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
          user: this.props.user,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.bankAccounts.data,
          page: query.page,
          totalCount: data.bankAccounts.total,
        };
      });
  };

  handleRemove = (id) => {
    confirmAlert({
      title: "تاییدیه حذف",
      message: "آیا واقعا می خواهید حذف کنید.",
      buttons: [
        {
          label: "بله",
          onClick: () => {
            client
              .mutate({
                mutation: MUTATION_REMOVE_BANK_ACCOUNT,
                variables: {
                  id: id,
                },
              })
              .then((res) => {
                let d = res.data.removeBankAccount;
                this.tableRef.current.onQueryChange();
                SuccessToast("با موفقیت حذف گردید");
              })
              .catch((err) => console.log(err));
          },
        },
        {
          label: "بی خیال",
          onClick: () => {},
        },
      ],
    });
  };

  render() {
    const { columns, data } = this.state;
    let title = "حساب های بانکی" + " " + (this.props.name ? this.props.name : "");
    return (
      <MaterialTableRtl
        tableRef={this.tableRef}
        columns={columns}
        data={this.remoteData}
        editLink={"/bank-account/edit/"}
        handleRemove={this.handleRemove}
        needExport={true}
        title={title}
        pdfName={this.props.pdfName ? this.props.pdfName : title}
      />
    );
  }
}

export default BankAccountList;
